import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import { useState, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { handlePositiveKeyDown } from '../../utils/keyboard.js';
import styles from './Toggle.module.css.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var EMPTY_OBJ = {};
function Toggle(props) {
  var className = props.className,
    _props$defaultChecked = props.defaultChecked,
    defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$htmlProps = props.htmlProps,
    htmlProps = _props$htmlProps === void 0 ? EMPTY_OBJ : _props$htmlProps,
    label = props.label,
    onChange = props.onChange;
  var _useState = useState(defaultChecked),
    _useState2 = _slicedToArray(_useState, 2),
    switchedOn = _useState2[0],
    setSwitchedOn = _useState2[1];
  var switchToggle = useCallback(function () {
    setSwitchedOn(!switchedOn);
    if (onChange) {
      onChange(!switchedOn);
    }
  }, [onChange, switchedOn]);
  var handleKeyDown = useCallback(function (e) {
    handlePositiveKeyDown(e, switchToggle);
  }, [switchToggle]);
  useEffect(function () {
    setSwitchedOn(defaultChecked);
  }, [defaultChecked]);
  return jsx("span", _objectSpread(_objectSpread({
    "aria-checked": switchedOn,
    className: cn(styles.checkbox, _defineProperty({}, styles.disabled, disabled), className),
    onClick: disabled ? undefined : switchToggle,
    onKeyDown: disabled ? undefined : handleKeyDown,
    role: 'checkbox',
    tabIndex: disabled ? -1 : 0
  }, htmlProps), {}, {
    children: jsxs("span", {
      className: styles.support,
      tabIndex: -1,
      children: [!!label && label.position === 'l' && jsx("span", {
        className: styles.textLabelLeft,
        children: label.text
      }), jsx("span", {
        className: "".concat(styles.switch, " ").concat(switchedOn ? styles.on : '')
      }), !!label && label.position === 'r' && jsx("span", {
        className: styles.textLabelRight,
        children: label.text
      })]
    })
  }));
}

export { Toggle };
